.chartArea {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-bottom: 1rem;
}

.otherArea {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}
.chartAndTabsContainer {
  background-color: var(--static-background-standard);
  border-radius: 1rem;
  border: 1px solid var(--static-divider-standard);
}

.container {
  padding: 2rem;
}

.accountSelect {
  padding-bottom: 2rem;
  margin-left: 5px;
}
.warning {
  border-radius: 6px;
  padding: 10px;
  background-color: var(--primary-enabled);
}
.header {
  margin-bottom: 2rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tabs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem;
}
